
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.359 9.18H4.516l3.75-4.193a.844.844 0 00-1.25-1.133L2.13 9.293l-.341.34a.885.885 0 00.17.906l5.058 5.609a.914.914 0 00.625.283.73.73 0 00.568-.227.822.822 0 00.057-1.19l-3.75-4.192h12.899a.873.873 0 00.852-.85.877.877 0 00-.91-.793z"}})])
          )
        }
      }
    